import { render, staticRenderFns } from "./WidgetsReportDocumentSubmission.vue?vue&type=template&id=56fca858&scoped=true"
import script from "./WidgetsReportDocumentSubmission.vue?vue&type=script&lang=js"
export * from "./WidgetsReportDocumentSubmission.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportDocumentSubmission.vue?vue&type=style&index=0&id=56fca858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fca858",
  null
  
)

export default component.exports